import React from 'react'
import { useState } from 'react'
import { capitalizeFirstLetterOfWords } from './util'

const DropdownWidget= ({ title,options,onSelectionChange }) => {
const [open,setOpen] = useState(false)
const [selected,setSelected] = useState(title)


const handleInputChange = (opt)=> {
  setOpen(false)
  setSelected(opt)
  onSelectionChange(opt)
};
  return (
    <div>
      <div className='row'>
          <div className='col s12' style={{
            width:"100%",
            border:"1px solid #D9D9D9",
            borderRadius:"5px",
            height:"56px",
            display:"flex",
            justifyContent:"space-between",
            padding:"0.1em 0.0em 0.1em 0.3em "
          }}
          onClick={()=>setOpen(!open)}
          > 
            <p>{capitalizeFirstLetterOfWords(selected)}</p>
            <div style={{
              margin:"15px 10px 0px 0px",
            }}>
              <i className='material-icons'> {open?'expand_less' :'expand_more'}</i>
            </div>
          </div>
      </div>
      {open &&
      <div className='row'
       data-aos="zoom-down"
      >
        <div className='col s12 ' style={{
            width:"100%",
            border:"1px solid #D9D9D9",
            borderRadius:"5px",
            minHeight:"50px",
            maxHeight:"400px",
            overflow: "auto",
            
          }}> 
            { options.map((data)=>
                <p 
                  style={{
                    padding:"10px 0px 10px 0px",
                    margin:"0px !important",
                    color:"#000000",
                    fontWeight:"800!important"

                  }}
                  onClick={()=>handleInputChange(data)}
                  key={data}
                >
                  <b>
                  {capitalizeFirstLetterOfWords(data)}
                  </b>

                </p>
             
              )
            }

        </div>
      </div>
      }

    </div>
  )
}

export default DropdownWidget